import React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { useMsal } from "@azure/msal-react";
import { Avatar, Stack } from "@mui/material";

import Breadcrumbs from "./breadcrumbs";
import { AccountCircle, MailOutline, Group } from "@mui/icons-material";
import useUserAccount from "./hooks/userAccountInfo";
import ColoredAvatar from "./hooks/colorAvatar";
import Loading from "./loading";

export default function UserInfo() {
  const { instance } = useMsal();
  const { userName, userRole, project, nameParts, loading } = useUserAccount(instance);

  const capitalizeFirstLetter = (str) =>
    str.charAt(0).toUpperCase() + str.slice(1);

  return (
    <div>
      <div style={{ paddingLeft: "2rem", marginBottom: "1rem" }}>
        <Breadcrumbs />
      </div>

      <div style={{ display: "flex", justifyContent: "center" }}>
        {loading ? (
          <Loading
            open
            type="skeleton"
            variant="form"
            rows={5}
            width="400px"
            height="70vh"
            position="center"
          />
        ) : (
          <Card sx={{ maxWidth: "100%" }}>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Stack direction="row" spacing={2} sx={{ my: 5 }}>
                {nameParts?.length ? (
                  <ColoredAvatar name={nameParts.join(" ")} size={100} />
                ) : null}
              </Stack>
            </div>
            <CardContent>
              <Typography
                gutterBottom
                variant="h5"
                component="div"
                sx={{ mb: 4 }}
              >
                User Details
              </Typography>

              <Typography
                variant="subtitle1"
                color="text.secondary"
                component="div"
                display="flex"
                align="center"
              >
                <AccountCircle sx={{ pr: 1 }} />{" "}
                {nameParts?.[0]} {nameParts?.[1] || ""}
              </Typography>

              <Typography variant="body2" component="div" color="text.secondary">
                <Typography
                  variant="subtitle1"
                  color="text.secondary"
                  component="div"
                  display="flex"
                  align="center"
                >
                  <MailOutline sx={{ pr: 1 }} /> {userName || null}
                </Typography>

                <Typography
                  variant="subtitle1"
                  color="text.secondary"
                  component="div"
                  display="flex"
                  align="center"
                >
                  <Group sx={{ pr: 1 }} />{" "}
                  {userRole ? capitalizeFirstLetter(userRole) : null}
                </Typography>
              </Typography>
            </CardContent>
          </Card>
        )}
      </div>
    </div>
  );
}